<template>
  <div class="ticket-list" v-loading="loading">
    <template v-if="tableData.length>0">
      <div class="group-tag-wrap">
        <div
          class="group-tag"
          v-for="(item, index) in groupTags"
          :key="index"
          @click="activeGroup = item.value"
          :class="{
            'active-group': activeGroup === item.value
          }">
          {{ item.label }}
        </div>
      </div>

      <div
        class="ticket-type box-shadow"
        v-for="(item, index) in tableData"
        :key="index">
        <div class="ticket-info">
          <p class="ticket-name">{{ item.name }}</p>
          <p class="ticket-price" v-if="type==='TICKET'">
            <span
              v-if="item.price_original"
              class="original-price">
              原价：<s>￥{{ item.price_original }}</s>
            </span>
            <span class="current-price">
              ￥{{ item.lowest_price || item.price }} <i>起</i>
            </span>
          </p>
        </div>

        <div class="ticket-tags">
          <el-tag
            type="warning"
            v-for="(tag, tagIndex) in item.tags"
            :key="tagIndex">{{ tag.name }}</el-tag>
          <div class="ticket-btn" @click="createOrder(item)">立即预订</div>
        </div>

        <div class="ticket-extra">
          <p class="info-link" @click="$refs.detailDialog.open(item)">门票详情 ></p>
        </div>
      </div>
    </template>

    <TicketDetail ref="detailDialog" :info="currentItem"></TicketDetail>
  </div>
</template>

<script>
import { getTicketList } from '@/api'
import TicketDetail from './TicketDetail'
import NoticeDialog from './NoticeDialog'

export default {
  props: {
    type: {
      type: String,
      default: 'TICKET'
    }
  },
  components: {
    TicketDetail,
    NoticeDialog
  },
  computed: {
    tableData () {
      if (this.activeGroup === '') {
        return this.ticketData
      } else {
        return this.ticketData.filter(item => {
          return item.category.id === this.activeGroup
        })
      }
    }
  },
  created () {
    this.getTicketList()
  },
  data () {
    return {
      loading: false,
      activeGroup: '',
      currentItem: {},
      groupTags: [],
      ticketData: []
    }
  },
  methods: {
    getTicketList () {
      this.loading = true

      getTicketList({
        type: this.type,
        pageNum: 0,
        pageSize: 0
      }).then(res => {
        this.getGroupTags(res.data.extraInfo.list)

        const rawList = res.data.extraInfo.list
        rawList.sort((a, b) => {
          return a.category.seq - b.category.seq
        })
        this.ticketData = rawList
      }).finally(() => {
        this.loading = false
      })
    },
    getGroupTags (list) {
      const result = list.reduce((prev, cur) => {
        if (!prev.some(item => item.value === cur.category.id)) {
          prev.push({
            value: cur.category.id,
            seq: cur.category.seq,
            label: cur.category.name || '其他'
          })
        }
        return prev
      }, [])
      result.sort((a, b) => {
        return a.seq - b.seq
      })
      result.unshift({
        value: '',
        label: '全部'
      })
      this.groupTags = result
    },
    createOrder (item) {
      const to = {
        TICKET: 'ticketOrder',
        BATCH: 'batchTicketOrder'
      }
      this.$router.push({
        name: to[this.type],
        params: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.blank{
  background: #fff; padding: 20px; border-radius: 5px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); font-size: 16px; text-align: center; margin-top: 10px; color: #666;
}
</style>
